/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_LeadInputs */

const en_mk_sec_pg_ledger_lead = /** @type {(inputs: Mk_Sec_Pg_Ledger_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A crossed row does not mean “coming soon”. It means it does not exist, and if you need it now you should know that before you sign up.`)
};

const id_mk_sec_pg_ledger_lead = /** @type {(inputs: Mk_Sec_Pg_Ledger_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baris bertanda silang bukan berarti "segera hadir". Itu berarti belum ada, dan kalau Anda membutuhkannya sekarang, sebaiknya Anda tahu sebelum mendaftar.`)
};

/**
* | output |
* | --- |
* | "A crossed row does not mean “coming soon”. It means it does not exist, and if you need it now you should know that before you sign up." |
*
* @param {Mk_Sec_Pg_Ledger_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_lead = /** @type {((inputs?: Mk_Sec_Pg_Ledger_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_lead(inputs)
	return en_mk_sec_pg_ledger_lead(inputs)
});